import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reason-edit',
  templateUrl: './reason-edit.component.html',
  styleUrls: ['./reason-edit.component.scss']
})
export class ReasonEditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
